import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
import apiClient from 'api/client';
import { fetchContractList } from 'api/actions/contracts';
import { toast } from 'components/Shared/Toast';
import {
  FormGroup,
  FormFeedback,
  Label,
  Input,
  CustomInput
} from 'reactstrap';

const ReferenceDocument = ({
  onChange,
  reference,
  addDividerOnTop = true,
  showReference = true,
}) => {
  const { t } = useTranslation();

  const handleDocumentChange = (a) => {
    onChange({ document: a.value, documentMissing: false });
  };
  const loadDocuments = async (val) => {
    try {
      const {
        data: { docs = [] },
      } = await apiClient(
        fetchContractList({
          url: '/contracts/all',
          page: 1,
          perPage: 30,
          search: `name|${val && val.length ? val : ''}`,
          limit: 30,
          filterown: true,
        })
      );
      return docs.map((doc) => ({
        label: `${doc.documentId}-${doc.name}`,
        value: doc.id,
      }));
    } catch (error) {
      console.error(error);
      toast.error(t('errors.ErrorFetching'));
      return [];
    }
  };

  const handleReferenceChange = (event) => {
    let join = event.target.checked;
    onChange({
      join,
      ...(!join && {
        participants: false,
      }),
      ...(!reference.document && { documentMissing: true }),
      ...(reference.document && { documentMissing: false }),
    });
  }

  const handleSelectChange = (event) => {
    onChange({ ...reference, copyMilestones: event.target.checked });
  }

  const handleParticipantsChange = (event) => {
    let participants = event.target.checked;
    onChange({ participants, ...(participants && { join: true }) });
  }
  return (
    <>
      {addDividerOnTop && <hr />}
      {showReference && (
        <>
          <FormGroup >
            <CustomInput
              type="switch"
              id="reference-checkbox"
              className="mb-2"
              onChange={handleReferenceChange}
              label={t('contracts.options.reference')}
            />
            <AsyncSelect
              styles={{
                menu: provided => ({ ...provided, zIndex: 3 })
              }}
              name="template"
              cacheOptions
              className="create-select"
              defaultOptions
              loadOptions={loadDocuments}
              placeholder={t('common.choose')}
              isDisabled={!reference.join}
              onChange={handleDocumentChange}
              noOptionsMessage={() => (
                <div>{t('contracts.new.no-documents')}</div>
              )}
            />

            <FormFeedback valid={!reference.documentMissing} invalid={String(reference.documentMissing && reference.join)}>
              {t('contracts.new.error_missing_document_link')}
            </FormFeedback>

          </FormGroup>
        </>
      )}
      <span className="font-weight-bold">{t('contracts.new.import')}</span>

      <CustomInput
        className="mt-2 mb-2"
        id="participants-checkbox"
        type="switch"
        checked={reference.participants}
        onChange={handleParticipantsChange}
        label={t('contracts.listing.participants')}
      />
      <CustomInput
        id="milestones-checkbox"
        type="switch"
        checked={reference.copyMilestones}
        onChange={handleSelectChange}
        label={t('contracts.listing.copyMilestones')}
      />
    </ >
  );
};
export default ReferenceDocument;
